// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1AS2w","right":"styles_right__3OemZ"};